import {PaginatedResult} from '../PaginatedResult';
import {Type} from 'class-transformer';
import {UserAdministrationSearchResult} from '../../users/AdministrationUser';

export class PaginatedAdministrationUsers extends PaginatedResult {

  @Type(() => UserAdministrationSearchResult)
  public result: Array<UserAdministrationSearchResult>;
}
